import * as dompurify from 'dompurify';
const purifier = dompurify['default'] as dompurify.DOMPurify;

export class StringFns {
  static isNullEmptyOrWhiteSpace(s: string | null | undefined): boolean {
    return s === null || s === undefined || s.match(/^ *$/) !== null;
  }

  static tagsrx = /<.*?>/g;

  /** Remove HTML tags from the string */
  static stripHtmlTags(s: string) {
    if (!s) {
      return s;
    }
    // TODO replace <br> with \n, &lt; with <, etc.
    return s.replace(this.tagsrx, '');
  }

  /** Sanitize HTML string using DOMPurify.  Removes css, javascript, unknown tags, etc. */
  static purify(s: string, cfg?: dompurify.Config) {
    return purifier.sanitize(s, cfg) as string;
  }

  static cleanString(inputString: string): string {
    // This regular expression matches any character that is NOT a letter (a-z, A-Z),
    // a number (0-9). The 'g' flag ensures all occurrences are replaced.
    const cleanedString = inputString.replace(/[^a-zA-Z0-9]/g, '');
    return cleanedString;
  }

  static isFirstCharAlpha(inputString: string): boolean {
    if (inputString.length === 0) {
      return false; // An empty string has no first character
    }
    return /^[a-zA-Z]/.test(inputString);
  }

  /**
   * Validates that the given string looks like an email address. Deliberately
   * permissive — accepts the common shape (something@something.something) without
   * trying to enforce every RFC 5322 nuance. Catches the obvious typos like
   * "foo", "@bar", "x x@y.com" without being overly strict on edge cases.
   */
  static isValidEmail(input: string | null | undefined): boolean {
    if (!input) return false;
    const trimmed = input.trim();
    if (trimmed.length === 0 || trimmed.length > 254) return false;
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed);
  }
}
